<template>
  <el-dialog
    title="Create Account"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="accountForm"
      v-loading="isSaving"
      :rules="rules"
      :model="account"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-model="account.name"
              placeholder="Account Name"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Address"
            prop="address"
          >
            <el-input
              v-model="account.address"
              placeholder="Address of account"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="8">
          <el-form-item
            label="Suburb"
            prop="suburb"
          >
            <el-autocomplete
              v-model="account.suburb"
              :fetch-suggestions="suburbQuerySearch"
              placeholder="Enter name of suburb"
              :trigger-on-focus="false"
              class="w-100"
              placement="top"
              :debounce="500"
              clearable
              @select="handleSelectSuburb"
            >
              <template v-slot="{ item }">
                {{ formatSuburbByLocation(item) }}
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="State"
            prop="state"
          >
            <el-input
              v-model="account.state"
              placeholder="E.g. Victoria"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Postcode"
            prop="postcode"
          >
            <el-input
              v-model="account.postcode"
              placeholder="E.g. 3000"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Contact"
            prop="contact"
          >
            <el-input
              v-model="account.contact"
              placeholder="E.g. John Smith"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Phone"
            prop="phone"
          >
            <el-input
              v-model="account.phone"
              placeholder="E.g. 03 9700 5555"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Fax"
            prop="fax"
          >
            <el-input
              v-model="account.fax"
              placeholder="E.g. 03 9700 5556"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Email"
            prop="email"
            :rules="[{ type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }]"
          >
            <el-input
              v-model="account.email"
              placeholder="E.g. john.smith@company.com"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="createAccount"
      >
        Create
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      account: null,
      crmAccTypes: [],
      isSaving: false,
      isFullscreen: false,
      isLoadingCrmAccountType: false,
      rules: {
        name: [
          { required: true, message: 'Name of the address is required', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Line one of the address is required', trigger: 'blur' }
        ],
        suburb: [
          { required: true, message: 'Please enter and select a suburb from the list', trigger: 'change' }
        ],
        state: [
          { required: true, message: 'State of the address is required', trigger: 'change' }
        ],
        postcode: [
          { required: true, message: 'Postcode of the address is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.account = new this.$sdk.account()
    this.loadLists()
  },
  methods: {
    createAccount () {
      this.$refs.accountForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.account.create(builder => {
            builder.include = ['acc_type', 'assets', 'b_group', 'crm_ac_type', 'metas', 'parent', 'portfolio.profile', 'stationary_type', 'assets', 'trading_term', 'time_cycle']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved', this.account)
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    loadLists () {
      this.isLoadingCrmAccountType = true
      this.$sdk.dictionary_crmactype.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'uuid:asc'
      })
        .then(res => {
          this.crmAccTypes = res
        })
        .finally(() => {
          this.isLoadingCrmAccountType = false
        })
    },
    suburbQuerySearch (queryString, cb) {
      this.$sdk.dictionary_location.list(builder => {
        builder.page = 1
        builder.limit = 50
        builder.filters = { dictionary_location_find: [queryString] }
        builder.order = 'suburb:asc'
      }).then(res => {
        cb(res)
      })
    },
    handleSelectSuburb (item) {
      this.account.suburb = item.suburb
      this.account.state = item.state
      this.account.postcode = item.postcode
    },
    formatSuburbByLocation (location) {
      if (location) {
        return `${location.suburb}, ${location.state}, ${location.postcode}`
      } else return ''
    }
  }
}
</script>

<style>

</style>
